import React, {PropTypes} from 'react';
import {station as api} from '../../../actions/api';
import {observer, inject} from 'mobx-react';
import {observable, toJS} from 'mobx';
import DataTable from "../../DataTable";
import Modal from "../../Modal";
import Spinner from "../../Spinner";
import {getDisplayDate} from "../../../libs/date";

@inject('userStore')
@observer
class StationMetaDataAudit extends React.Component {

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  }

  @observable isLoading = false;
  @observable audit = [];
  @observable selectedAudit = null;
  slug = `/station/${this.props.params.id}/meta-data-audit`;

  columns = [
    { key: 'audit_timestamp', label: 'Audit Timestamp' },
    { key: 'user_name', label: 'Edited By' },
  ]

  componentWillMount() {
    const {params: {id}, userStore} = this.props;
    if(!userStore.items.length) userStore.fetchItems();

    this.isLoading = true;
    api.fetchMetaDataAudit(id).then(res => {
      this.isLoading = false;
      this.audit = res.map((item, id) => (Object.assign(item, {id, audit_timestamp: getDisplayDate(new Date(item.audit_timestamp).toISOString())})));
    }).catch(err => {
      this.isLoading = false;
      this.context.notify.error({message: err.toString()})
    })
  }

  onSelectAudit = e => {
    let selectedAudit = this.audit.find(item => item.audit_timestamp === e.audit_timestamp && item.user_id === e.user_id);
    this.selectedAudit = selectedAudit;
    this.context.router.push(`${this.slug}/${selectedAudit.id}`);
  };

  render() {
    const {params: {auditId}, userStore} = this.props;

    if(userStore.isLoading || this.isLoading) return <Spinner/>;

    let data = this.audit.sort((a,b) => new Date(a.audit_timestamp).valueOf() > new Date(b.audit_timestamp).valueOf() ? -1 : 1).map((item, i) => ({
      id: `${i}-${item.user}-${item.audit_timestamp}`,
      audit_timestamp: item.audit_timestamp,
      user_id: item.user_id,
      user_name: userStore.findById(item.user_id).name
    }));

    return (
      <div>
        <h3>Station Meta-Data Audit</h3>
        <DataTable data={data} columns={this.columns} onSelect={this.onSelectAudit} slug={this.slug}/>
        {auditId && this.selectedAudit && <Modal title={`${this.selectedAudit.audit_timestamp}`} slug={this.slug}>
          {React.cloneElement(this.props.children, {audits: this.selectedAudit.audits, slug: this.slug})}
        </Modal>}
      </div>
    );
  }
}

export default StationMetaDataAudit;


// WEBPACK FOOTER //
// ./src/components/Station/MetaData/StationMetaDataAudit.js